export default "__VITE_ASSET__DQzJhPx4__"